import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

import { CartModule } from 'src/app/shared/components/cart/cart.module';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { PaymentFormModule } from 'src/app/shared/components/payment-form/payment-form.module';

import { CartService } from 'src/app/shared/services/cart.service';
import { CheckoutService } from 'src/app/shared/services/checkout.service';
import { SilentOrderService } from 'src/app/shared/services/silent-order.service';
import { FraudnetService } from "../../shared/services/fraudnet.service";

import { CheckoutPaymentComponent } from './payment.component';
import {ProductChoiceModule} from "../../shared/components/product-choice/product-choice.module";

@NgModule({
    imports: [
        CommonModule,
        
        MatBottomSheetModule,
        CartModule,
        HeroModule,
        PaymentFormModule,
        ProductChoiceModule
    ],
  exports: [
    CheckoutPaymentComponent
  ],
  providers: [
    CartService,
    CheckoutService,
    SilentOrderService,
    FraudnetService
  ],
  declarations: [
    CheckoutPaymentComponent
  ]
})
export class CheckoutPaymentModule { }
